import { useEffect, useState } from 'react';
import { safeStorage } from '../utils/safeStorage';

export const ORG_BUNDLE_SLUGS_STORAGE_KEY = 'evv_org_bundle_slugs';
export const ORG_BUNDLE_SLUGS_UPDATED_EVENT = 'arasync:org-bundle-slugs-updated';

function readOrgBundleSlugs() {
  try {
    const raw = safeStorage.getItem(ORG_BUNDLE_SLUGS_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/**
 * Bundle slugs the current organization holds.
 *
 * AdminShell fetches /bundles/my-bundles and caches the slugs in
 * `evv_org_bundle_slugs`; this reads that rather than issuing a second request.
 * It also responds to AdminShell's same-tab update event so a component that
 * mounts while bundles are loading does not remain stuck on a stale value.
 *
 * Returns [] when unknown (not yet loaded, or a platform admin with no tenant).
 * Callers MUST treat empty as "unknown" and not filter — an empty picker is a
 * worse failure than an over-inclusive one.
 */
export function useOrgBundleSlugs() {
  const [slugs, setSlugs] = useState(readOrgBundleSlugs);

  useEffect(() => {
    const syncFromStorage = () => setSlugs(readOrgBundleSlugs());
    const syncAcrossTabs = (event) => {
      if (event.key === ORG_BUNDLE_SLUGS_STORAGE_KEY) syncFromStorage();
    };

    window.addEventListener(ORG_BUNDLE_SLUGS_UPDATED_EVENT, syncFromStorage);
    window.addEventListener('storage', syncAcrossTabs);
    return () => {
      window.removeEventListener(ORG_BUNDLE_SLUGS_UPDATED_EVENT, syncFromStorage);
      window.removeEventListener('storage', syncAcrossTabs);
    };
  }, []);

  return slugs;
}
